import { createAsyncThunk } from '@reduxjs/toolkit';
import { alertsApi } from 'services/alerts/alerts.api';

export const closeAlertThunk = createAsyncThunk(
  'alert/closeAlert',
  async ({ alertId, notes }, { dispatch, rejectWithValue }) => {
    try {
      await dispatch(alertsApi.endpoints.setAlertEnd.initiate({ alertId, notes })).unwrap();

      return { alertId };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
